function fragmentRedirects(fragmentRedirects) {
	var fragmentUrl = window.location.hash;
	if (fragmentRedirects.length && fragmentUrl != '') {
		var fragmentRedirect = fragmentRedirects.filter(f => f.fragmentUrl == fragmentUrl );
		if (fragmentRedirect.length) {
			// Delay a little to ensure that page events are able to process
			setTimeout(function(){
				window.location.href = fragmentRedirect[0].destinationUrl;
			}, 100);
			
		}
	}
}

export {
	fragmentRedirects,
};